import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICarrier } from '../../../models/carrier';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { TealCompReferralSubmission } from '../../../models/teal-comp-referral';
import { ReferralState } from '../../../state/referrals/referral-state';
import { Store } from '@ngxs/store';
import { NgIf } from '@angular/common';
import { ILocation } from '@harlowe/core';

@Component({
  selector: 'app-carrier-editor',
  standalone: true,
  imports: [CardModule,FloatLabelModule,InputTextModule,FormsModule,ButtonModule,ButtonGroupModule, NgIf],
  templateUrl: './carrier-editor.component.html',
  styleUrl: './carrier-editor.component.scss'
})
export class CarrierEditorComponent implements OnInit
{
  @Input() carrier:ICarrier = {} as ICarrier;
  @Output() saved: EventEmitter<ICarrier> = new EventEmitter<ICarrier>();
  @Output() cancelled = new EventEmitter();

  //Listen for whether the user has selected a referral to work with
  selectedReferral$ = this._store.select(ReferralState.currentReferral);
  activeSubmission?: TealCompReferralSubmission;
  


  constructor(private _store: Store)
  {
    this.selectedReferral$.subscribe
    (
      referral =>
        {
          this.activeSubmission = referral?.submission;
        }
    )
  }

  ngOnInit(): void 
  {
    if(!this.carrier.companyLocation)
    {
      this.carrier.companyLocation = {} as ILocation;
    }
  }

  saveButtonPressed(event: MouseEvent)
  {
    this.saved.emit(this.carrier);
  }

  cancelButtonPressed(event: MouseEvent)
  {
    this.cancelled.emit();
  }

  allowSave() : boolean
  {
    return this.carrier.name != null;
  }

  fillFromSubmission()
  {
    if(this.activeSubmission)
    {

      this.carrier.name = this.activeSubmission.payerName;
    }
  }

  clearForm()
  {
    this.carrier = {} as ICarrier;
  }
}
